<template>
    <div class="container admin-table-page">
        <div class="param-title-wrap">
            <b-button class="page-back-btn mr-2" variant="link" @click="goBack">
                <font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" />
            </b-button>
            <h2 class="param-title">{{ labels.title }}</h2>
        </div>

        <div class="admin-table-block mt-4" v-if="currency?.length">
            <CorporateDataTable
                :items="currencyTableItems"
                :fields="allFields"
                :filter-defs="tableFilterDefs"
                :labels="tableLabels"
                :default-per-page="10"
                :page-options="[10, 20, 50, 100]"
                :narrow="false"
                :table-min-height="500"
                :table-max-height="500"
            >
                <template #toolbar-actions>
                    <b-button size="sm" class="table-toolbar-add-btn" @click="goToCreateCurrency()">
                        {{ labels.create }}
                    </b-button>
                </template>

                <template #cell(nombre)="data">
                    <div class="text-left">{{ data.item?.nombre }}</div>
                </template>

                <template #cell(acronimo)="data">
                    <div class="text-center">{{ data.item?.acronimo }}</div>
                </template>

                <template #cell(isFuncional)="data">
                    <div class="text-center">{{ f_funcional(data.item?.isFuncional) }}</div>
                </template>

                <template #cell(url)="data">
                    <div class="text-center">{{ data.item?.url }}</div>
                </template>

                <template #cell(accionEdit)="data">
                    <b-button
                        style="background-color: #FF924C; width: 30px; height: 30px;"
                        class="md-fab md-primary table-action-btn"
                        @click.stop="editCurrency(data.item.id)"
                    >
                        <i><font-awesome-icon :icon="['fas', 'pencil-alt']" size="xs"/></i>
                    </b-button>
                </template>

                <template #cell(accionDelete)="data">
                    <b-button
                        class="reset-btn-danger table-action-btn"
                        style="width: 30px; height: 30px; padding: 0; display: flex; align-items: center; justify-content: center;"
                        @click.stop="confirmDeleteCurrency(data.item.id)"
                    >
                        <i><font-awesome-icon :icon="['fas', 'trash']" size="xs"/></i>
                    </b-button>
                </template>
            </CorporateDataTable>
        </div>
        <div class="admin-table-block mt-4" v-else>
            <h5>{{ labels.empty }}</h5>
        </div>

        <!-- Modal Crear -->
        <b-modal
            :model-value="showDialogCreate"
            :no-close-on-backdrop="true"
            hide-footer
                        centered
            :title="labels.createModalTitle"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog create-currency-dialog"
         @hide="closeCreateModal">
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ labels.createInfoTitle }}</div>
                    <div class="password-policy-subtitle">{{ labels.createInfoText }}</div>
                </div>

                <!-- Campo: Nombre -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.name }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="newCurrency.nombre"
                            type="text"
                            class="form-input"
                            placeholder="Nombre de la moneda"
                        />
                    </b-col>
                </b-row>

                <!-- Campo: Acrónimo -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.acronym }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="newCurrency.acronimo"
                            type="text"
                            class="form-input"
                            placeholder="Acrónimo de la moneda"
                        />
                    </b-col>
                </b-row>

                <!-- Campo: Funcional -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.funcional }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select
                            v-model="newCurrency.isFuncional"
                            class="form-input"
                        >
                            <b-form-select-option :value="0">No</b-form-select-option>
                            <b-form-select-option :value="1">Funcional</b-form-select-option>
                            <b-form-select-option :value="2">Alterna</b-form-select-option>
                            <b-form-select-option :value="3">Alterna 2</b-form-select-option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <!-- Campo: URL -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.url }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="newCurrency.url"
                            type="text"
                            class="form-input"
                            placeholder="URL de la moneda"
                        />
                    </b-col>
                </b-row>

                <!-- Botones de acción -->
                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="mr-2 reset-btn-secondary" @click="closeCreateModal">{{ labels.close }}</b-button>
                    <b-button class="reset-btn-primary" @click="createCurrency" :disabled="isLoading">
                        <b-spinner v-if="isLoading" small class="mr-1"></b-spinner>
                        {{ labels.save }}
                    </b-button>
                </div>
            </div>
        </b-modal>

        <!-- Modal Editar -->
        <b-modal
            :model-value="showDialogEdit"
            :no-close-on-backdrop="true"
            hide-footer
                        centered
            :title="labels.modalTitle"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog edit-currency-dialog"
         @hide="closeModal">
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ labels.infoTitle }}</div>
                    <div class="password-policy-subtitle">{{ labels.infoText }}</div>
                </div>

                <!-- Campo: Nombre -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.name }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="formEdit.nameCurrency"
                            type="text"
                            class="form-input"
                            placeholder="Nombre de la moneda"
                        />
                    </b-col>
                </b-row>

                <!-- Campo: Acrónimo -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.acronym }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="formEdit.acronym"
                            type="text"
                            class="form-input"
                            placeholder="Acrónimo de la moneda"
                        />
                    </b-col>
                </b-row>

                <!-- Campo: Funcional -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.funcional }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select
                            v-model="formEdit.isFuncional"
                            class="form-input"
                        >
                            <b-form-select-option :value="0">No</b-form-select-option>
                            <b-form-select-option :value="1">Funcional</b-form-select-option>
                            <b-form-select-option :value="2">Alterna</b-form-select-option>
                            <b-form-select-option :value="3">Alterna 2</b-form-select-option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <!-- Campo: URL -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.url }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="formEdit.url"
                            type="text"
                            class="form-input"
                            placeholder="URL de la moneda"
                        />
                    </b-col>
                </b-row>

                <!-- Botones de acción -->
                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="mr-2 reset-btn-secondary" @click="closeModal">{{ labels.close }}</b-button>
                    <b-button class="reset-btn-primary" @click="editaInfoCurrency" :disabled="isLoading">
                        <b-spinner v-if="isLoading" small class="mr-1"></b-spinner>
                        {{ labels.save }}
                    </b-button>
                </div>
            </div>
        </b-modal>

        <!-- Modal Confirmación Eliminar -->
        <InacticaItem 
            :InactivaItem="showDeleteModal" 
            @confirmDelete="confirmDelete" 
            @cierraModal="closeDeleteModal"
        />
    </div>
</template>

<script>
import Currency from "@/services/Currency"
import CorporateDataTable from "../utils/CorporateDataTable.vue"
import InacticaItem from "../utils/InacticaItem.vue"

export default {
    name: "ManageCurrency",
    components: {
        CorporateDataTable,
        InacticaItem
    },
    data: () => ({
        currency: [],
        isLoading: false,
        showDialogEdit: false,
        showDialogCreate: false,
        showDeleteModal: false,
        currencyIdToDelete: null,
        newCurrency: {
            nombre: '',
            acronimo: '',
            isFuncional: 0,
            url: ''
        },
        formEdit: {
            nameCurrency: '',
            acronym: '',
            isFuncional: 0,
            url: '',
            idCurrency: ''
        }
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Monedas",
                    create: "Crear Moneda",
                    name: "Nombre",
                    acronym: "Acrónimo",
                    funcional: "Funcional",
                    url: "URL",
                    edit: "Editar",
                    delete: "Eliminar",
                    empty: "No hay monedas registradas",
                    noMatches: "No se encontraron resultados",
                    searchPlaceholder: "Buscar en la tabla...",
                    rowsPerPage: "Filas por página:",
                    noSort: "Sin orden",
                    sortAsc: "A-Z / Menor a mayor",
                    sortDesc: "Z-A / Mayor a menor",
                    columns: "Columnas",
                    showAllColumns: "Mostrar todas",
                    filters: "Filtros",
                    clearFilters: "Limpiar filtros",
                    filterName: "Filtrar nombre...",
                    filterAcronym: "Filtrar acrónimo...",
                    save: "Guardar",
                    close: "Cerrar",
                    modalTitle: "Editar Moneda",
                    infoTitle: "Datos de la moneda",
                    infoText: "Actualiza la información de la moneda.",
                    createModalTitle: "Crear Moneda",
                    createInfoTitle: "Nueva moneda",
                    createInfoText: "Completa la información para registrar una nueva moneda."
                }
            } else {
                return {
                    title: "Currencies",
                    create: "Create Currency",
                    name: "Name",
                    acronym: "Acronym",
                    funcional: "Functional",
                    url: "URL",
                    edit: "Edit",
                    delete: "Delete",
                    empty: "No currencies registered",
                    noMatches: "No results found",
                    searchPlaceholder: "Search in table...",
                    rowsPerPage: "Rows per page:",
                    noSort: "No sorting",
                    sortAsc: "A-Z / Low to high",
                    sortDesc: "Z-A / High to low",
                    columns: "Columns",
                    showAllColumns: "Show all",
                    filters: "Filters",
                    clearFilters: "Clear filters",
                    filterName: "Filter name...",
                    filterAcronym: "Filter acronym...",
                    save: "Save",
                    close: "Close",
                    modalTitle: "Edit Currency",
                    infoTitle: "Currency information",
                    infoText: "Update the currency information.",
                    createModalTitle: "Create Currency",
                    createInfoTitle: "New currency",
                    createInfoText: "Complete the information to register a new currency."
                }
            }
        },
        currencyTableItems() {
            return (this.currency || []).map((item) => ({
                ...item,
                nombre: item?.nombre || '',
                acronimo: item?.acronimo || '',
                isFuncional: item?.isFuncional || 0,
                url: item?.url || ''
            }))
        },
        allFields() {
            return [
                { key: 'nombre', label: this.labels.name, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle' },
                { key: 'acronimo', label: this.labels.acronym, sortable: true, thClass: 'text-center', tdClass: 'text-center align-middle' },
                { key: 'isFuncional', label: this.labels.funcional, sortable: true, thClass: 'text-center', tdClass: 'text-center align-middle' },
                { key: 'url', label: this.labels.url, sortable: true, thClass: 'text-center', tdClass: 'text-center align-middle' },
                { key: 'accionEdit', label: this.labels.edit, thClass: 'text-center', tdClass: 'text-center align-middle', sortable: false },
                { key: 'accionDelete', label: this.labels.delete, thClass: 'text-center', tdClass: 'text-center align-middle', sortable: false }
            ]
        },
        tableFilterDefs() {
            return [
                { key: 'nombre', type: 'text', placeholder: this.labels.filterName },
                { key: 'acronimo', type: 'text', placeholder: this.labels.filterAcronym }
            ]
        },
        tableLabels() {
            return {
                noRow: this.labels.empty,
                noMatches: this.labels.noMatches,
                searchPlaceholder: this.labels.searchPlaceholder,
                rowsPerPage: this.labels.rowsPerPage,
                noSort: this.labels.noSort,
                sortAsc: this.labels.sortAsc,
                sortDesc: this.labels.sortDesc,
                columns: this.labels.columns,
                showAllColumns: this.labels.showAllColumns,
                filters: this.labels.filters,
                clearFilters: this.labels.clearFilters
            }
        }
    },
    methods: {
        goBack() {
            this.$router.back()
        },
        
        f_funcional(opcion) {
            if (opcion == 1) return "Funcional"
            if (opcion == 2) return "Alterna"
            if (opcion == 3) return "Alterna 2"
            return "No"
        },
        
        goToCreateCurrency() {
            this.showDialogCreate = true
            this.newCurrency = {
                nombre: '',
                acronimo: '',
                isFuncional: 0,
                url: ''
            }
        },
        
        closeCreateModal() {
            this.showDialogCreate = false
        },
        
        createCurrency() {
            this.isLoading = true
            this.newCurrency.idUser = this.$store.state.userId
            
            Currency.createCurrency(this.newCurrency)
                .then(() => {
                    this.$toast.success(this.$store.state._language == "es-ES" 
                        ? "Moneda creada exitosamente" 
                        : "Currency created successfully")
                    this.closeCreateModal()
                    this.cargarMonedas()
                })
                .catch((err) => {
                    console.error(err)
                    let errorMessage = this.$store.state._language == "es-ES" 
                        ? "Error al crear la moneda" 
                        : "Error creating currency"
                    
                    if (err.response && err.response.data) {
                        if (err.response.status == 412) {
                            errorMessage = this.$store.state._language == "es-ES" 
                                ? "La moneda ya se encuentra registrada" 
                                : "This currency is already registered"
                        } else if (err.response.data.message) {
                            errorMessage = err.response.data.message
                        }
                    }
                    
                    this.$toast.error(errorMessage)
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        
        editCurrency(id) {
            this.showDialogEdit = true
            const currentIdx = this.currency.findIndex((obj) => obj.id == id)
            this.dialogItem = this.currency[currentIdx]
            this.formEdit.nameCurrency = this.dialogItem.nombre || ''
            this.formEdit.isFuncional = this.dialogItem.isFuncional || 0
            this.formEdit.acronym = this.dialogItem.acronimo || ''
            this.formEdit.url = this.dialogItem.url || ''
            this.formEdit.idCurrency = id
        },
        
        closeModal() {
            this.showDialogEdit = false
            this.formEdit = {
                nameCurrency: '',
                acronym: '',
                isFuncional: 0,
                url: '',
                idCurrency: ''
            }
        },
        
        editaInfoCurrency() {
            if (this.formEdit.isFuncional > 0) {
                const currentIdx = this.currency.findIndex((obj) =>
                    obj.isFuncional == this.formEdit.isFuncional)
                
                if (currentIdx !== -1) {
                    if (this.currency[currentIdx].id != this.formEdit.idCurrency) {
                        this.$toast.error("La moneda " + this.currency[currentIdx].nombre + " tiene ya la condición")
                        this.formEdit.isFuncional = 0
                        return
                    }
                }
            }
            
            this.isLoading = true
            Currency.updateCurrency(this.formEdit)
                .then(() => {
                    this.$toast.success("Moneda editada correctamente")
                    
                    const index = this.currency.findIndex(obj => obj.id == this.formEdit.idCurrency)
                    if (index !== -1) {
                        this.currency[index] = {
                            ...this.currency[index],
                            nombre: this.formEdit.nameCurrency,
                            acronimo: this.formEdit.acronym,
                            isFuncional: this.formEdit.isFuncional,
                            url: this.formEdit.url
                        }
                    }
                    
                    this.closeModal()
                })
                .catch((err) => {
                    console.error(err)
                    this.error = true
                    this.$toast.error("Error al editar la moneda")
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        
        confirmDeleteCurrency(id) {
            this.currencyIdToDelete = id
            this.showDeleteModal = true
        },
        
        closeDeleteModal() {
            this.showDeleteModal = false
            this.currencyIdToDelete = null
        },
        
        confirmDelete() {
            if (!this.currencyIdToDelete) return
            this.deleteCurrency(this.currencyIdToDelete)
        },
        
        deleteCurrency(id) {
            this.isLoading = true
            Currency.deleteCurrency(id)
                .then(() => {
                    this.$toast.success(this.$store.state._language == "es-ES" 
                        ? "Moneda eliminada correctamente" 
                        : "Currency deleted successfully")
                    this.currency = this.currency.filter(obj => obj.id != id)
                    this.showDeleteModal = false
                    this.currencyIdToDelete = null
                })
                .catch((err) => {
                    console.error(err)
                    this.$toast.error(this.$store.state._language == "es-ES" 
                        ? "Error al eliminar la moneda" 
                        : "Error deleting currency")
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        
        cargarMonedas() {
            this.isLoading = true
            Currency.getAllCurrency()
                .then((result) => {
                    this.currency = result.data.currency || []
                })
                .catch((err) => {
                    console.error(err)
                    this.error = true
                    this.$toast.error("Error al cargar las monedas")
                })
                .finally(() => {
                    this.isLoading = false
                })
        }
    },
    mounted() {
        this.cargarMonedas()
    }
}
</script>

<style src="../main.css"></style>
